/*
 * @Date: 2021-03-19 10:42:28
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-06-09 14:17:01
 * @FilePath: /daodao-biz-front/src/store/further.ts
 */
// @ts-ignore
import scheme from '@/components/further/workbench/scheme'
import {getDrafts, getEnrollmentClientInfo, saveDrafts, saveZySchemeV2} from '@/request/further'
import {merge} from 'lodash-es'
import {ActionContext} from 'vuex'
import {Further} from '@/interface/further.interface'
import {Common} from '@/interface/common.interface'

interface State {
  timeId: number
  zybId: string
  zybName: string
  zybSortType: number
  statusStat: Further.ServerTabItem[]
  clientInfo: Further.ClientInfo
  enrollmentClientInfo: Further.EnrollmentClientInfo
  stuOriginalScore: Further.StuOriginalScore
  scoreDetail: Further.ScoreDetail
  batch: Further.BatchListItem
  enroll_admission_dimension: Further.EnrollAdmissionDimension
  sorted_year: number
  provisionalScheme: Further.ZyFullItem[]
  provisionalSchemeLoading: boolean
  provisionalScheme_isAdd: boolean
  // 志愿表是否可以回退
  lastDraftsId: number
  currentRecommendConf: Further.RecommendConf
  currentTableConfig: any
  zyb_conf: Further.ZybConf
  schoolDrawerInfo: {
    visible: boolean
    schId: string
    province: string
  }
  majorDrawerInfo: {
    visible: boolean
    majorId: string
    province: string
  }
  bookInfo: {
    visible: boolean
    academicYear?: number
    euId?: string
    emId?: string
    euInfo?: Further.EuFullItem
    emListItem?: Further.EmFullItem
  }
}

const defaultClientInfo = {
  orgId: '',
  clientId: '',
  mobilePhone: '',
  name: '',
  gender: '',
  birth: '',
  areaCode: '',
  school: '',
  grade: '',
}

const defaultStuOriginalScore = {
  user_id: 0,
  enroll_category: 0,
  enroll_mode: 0,
  stu_province_id: '',
  wenli: 0,
  required_course_info: [],
  sec_required_course_info: [],
  diploma_score_info: [],
}

const defaultScoreDetail = {
  has_score: true,
  stu_province_id: '',
  stu_province_id_desc: '',
  wenli: 0,
  wenli_desc: '',
  diploma_mix: true,
  course_desc: '',
  user_diploma_score: [],
}

export default {
  namespaced: true,
  state: {
    zybId: '',
    zybName: '',
    statusStat: [],
    clientInfo: {
      orgId: '',
      clientId: '',
      mobilePhone: '',
      name: '',
      gender: '',
      birth: '',
      areaCode: '',
      school: '',
      grade: '',
    },
    enrollmentClientInfo: {},
    stuOriginalScore: merge({}, defaultStuOriginalScore),
    scoreDetail: merge({}, defaultScoreDetail),
    batch: {
      batchName: '',
    },
    currentRecommendConf: {},
    enroll_admission_dimension: merge(
      {},
      {
        academic_year: 0,
        enroll_category: 0,
        enroll_mode: 0,
        wenli: 0,
        diploma_id: 0,
        batch: 0,
        batch_ex: 0,
        enroll_stage: 0,
        exam_type: 0,
        exam_category: 0,
      }
    ),
    lastDraftsId: 0,
    provisionalScheme: [],
    provisionalScheme_isAdd: false,
    provisionalSchemeLoading: false,
    zyb_conf: {
      province_id: 'string',
      enroll_category: 0,
      enroll_mode: 0,
      diploma_id: 0,
      batch: 0,
      batch_ex: 0,
      zy_no: 100,
      zy_seq: 1,
      major_no: 1,
      major_seq: 2,
    },
    schoolDrawerInfo: {
      visible: false,
      schId: '',
      province: '',
    },
    majorDrawerInfo: {
      visible: false,
      majorId: '',
      province: '',
    },
    bookInfo: {
      visible: false,
    },
  },
  getters: {
    // 正在填报批次
    batchName: (state: State) => state.batch,
    // 工作台临时志愿表
    getProvisionalScheme: (state: State) => state.provisionalScheme,
    // 是否可以回退
    isCanUndo: (state: State) => {
      return state.lastDraftsId !== 0
    },
    // 获取志愿表序号
    getZySeqText: (state: State) => {
      // 字母表
      const numCase: any[] = []
      for (let i = 0; i < 330; i++) {
        numCase.push(i.toString())
      }
      const upperCase = [
        '',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ]
      const lowerCase = [
        '',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
      ]
      switch (state.zyb_conf.zy_seq) {
        case 2:
          return upperCase
        case 3:
          return lowerCase
        default:
          return numCase
      }
    },
    getMajorSeqText: (state: State) => {
      // 字母表
      const numCase: any[] = []
      for (let i = 0; i < 330; i++) {
        numCase.push(i.toString())
      }
      const upperCase = [
        '',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'L',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ]
      const lowerCase = [
        '',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'l',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
      ]
      switch (state.zyb_conf.major_seq) {
        case 2:
          return upperCase
        case 3:
          return lowerCase
        default:
          return numCase
      }
    },
  },
  mutations: {
    setZybId(state: State, payload: string) {
      if (state.zybId !== payload) {
        state.zybId = payload
        state.provisionalScheme = []
      }
    },
    setZybName(state: State, payload: string) {
      state.zybName = payload
    },
    setZybSortType(state: State, payload: number) {
      if (state.zybSortType !== payload) {
        scheme.sortZyb(payload)
      }
      state.zybSortType = payload
    },
    setClientInfo(state: State, payload: Further.ClientInfo) {
      state.clientInfo = {
        ...payload,
      }
    },
    setEnrollmentClientInfo(state: State, payload: Further.EnrollmentClientInfo) {
      state.enrollmentClientInfo = {
        ...payload,
      }
    },
    setStuOriginalScore(state: State, payload: Further.StuOriginalScore) {
      state.stuOriginalScore = {
        ...payload,
      }
    },
    setScoreDetail(state: State, payload: Further.ScoreDetail) {
      state.scoreDetail = {
        ...payload,
      }
    },
    setBatch(state: State, payload: Further.BatchListItem) {
      state.batch = {
        ...payload,
      }
    },
    setZybConf(state: State, payload: Further.ZybConf) {
      state.zyb_conf = {
        ...payload,
      }
    },
    setCurrentRecommendConf(state: State, payload: Further.RecommendConf) {
      state.currentRecommendConf = {
        ...payload,
      }
    },
    SET_PROVISIONALSCHEME(state: State, payload: Further.ZyFullItem[]) {
      state.provisionalScheme = payload
    },
    SET_ISADD(state: State, payload: any) {
      state.provisionalScheme_isAdd = payload
    },
    SET_PROVISIONALSCHEME_LOADING(state: State, payload: boolean) {
      state.provisionalSchemeLoading = payload
    },
    setLastDraftsId(state: State, payload: number) {
      state.lastDraftsId = payload
    },
    setTimeId(state: State, payload: number) {
      if (payload === 0 && state.timeId) {
        clearInterval(state.timeId)
      }
      state.timeId = payload
    },
    setSchoolDrawerInfo(
      state: State,
      payload: {
        visible: boolean
        schId: string
        province: string
      }
    ) {
      state.schoolDrawerInfo = {...payload}
    },
    setMajorDrawerInfo(
      state: State,
      payload: {
        visible: boolean
        majorId: string
        province: string
      }
    ) {
      state.majorDrawerInfo = {...payload}
    },
    setBookInfo(state: State, payload: any) {
      state.bookInfo = {...payload}
    },
  },
  actions: {
    // 初始化用户信息
    async initClient(ctx: any, payload: {
      clientId: Common.ClientId,
      active_item: any
    } | undefined) {
      ctx.commit('setClientInfo', merge({}, defaultClientInfo))
      ctx.commit('setEnrollmentClientInfo', {})
      ctx.commit('setStuOriginalScore', merge({}, defaultStuOriginalScore))
      ctx.commit('setScoreDetail', merge({}, defaultScoreDetail))
      if (payload) {
        await ctx.dispatch('updateClient', payload)
      }
    },
    // 更新用户信息
    async updateClient(ctx: any, payload: { clientId: Common.ClientId, active_item: any, ignoreScorDetail: any }) {
      if (payload?.active_item?.toggleSubject === true) {
        payload.ignoreScorDetail = true
      } else {
        payload.ignoreScorDetail = false
      }
      const res = await getEnrollmentClientInfo(payload)
      ctx.commit('setClientInfo', res.client)
      ctx.commit('setEnrollmentClientInfo', res.enrollmentClientInfo)
      ctx.commit('setStuOriginalScore', res.stuOriginalScore)
      if (res.scoreDetail) {
        ctx.commit('setScoreDetail', res.scoreDetail)
      }
    },
    // j
    async getCurProvisionalScheme(ctx: ActionContext<State, any>, payload: { useDraft: boolean; callback: Function }) {
      ctx.commit('SET_PROVISIONALSCHEME_LOADING', true)
      // 先清空
      ctx.commit('setLastDraftsId', 0)
      ctx.commit('SET_PROVISIONALSCHEME', [])
      try {
        if (payload.useDraft && ctx.state.clientInfo.clientId) {
          const {batch, enrollCategory, enrollMode, enrollStage, diplomaId, batchEx, academicYear, wenli} =
            ctx.state.batch
          const {zyContent} = await getDrafts({
            clientId: ctx.state.clientInfo.clientId,
            draftsId: 0,
            zybId: '0',
            enrollCategory,
            enrollMode,
            diplomaId,
            batch,
            batchEx,
            enrollStage,
            academic_year: academicYear,
            wenli,
          })
          ctx.commit('SET_PROVISIONALSCHEME', zyContent)
        }
      } catch (error) {
      } finally {
        ctx.commit('SET_PROVISIONALSCHEME_LOADING', false)
      }
      payload.callback && payload.callback()
    },
    // 上一步回撤
    async goBackDrafts(ctx: ActionContext<State, any>) {
      if (ctx.state.lastDraftsId) {
        ctx.commit('SET_PROVISIONALSCHEME_LOADING', true)
        const {batch, enrollCategory, enrollMode, enrollStage, diplomaId, batchEx, academicYear, wenli} =
          ctx.state.batch
        const {zyContent} = await getDrafts({
          clientId: ctx.state.clientInfo.clientId,
          draftsId: ctx.state.lastDraftsId,
          zybId: ctx.state.zybId || '0',
          enrollCategory,
          enrollMode,
          diplomaId,
          batch,
          batchEx,
          enrollStage,
          academic_year: academicYear,
          wenli,
        })
        ctx.dispatch('setProvisionalScheme', {list: zyContent, isUndo: true})
        ctx.commit('SET_PROVISIONALSCHEME_LOADING', false)
      }
    },
    // 保存临时志愿表
    async setProvisionalScheme(
      ctx: ActionContext<State, any>,
      payload: { list: Further.ZyFullItem[]; isUndo?: boolean; changeSortType?: boolean }
    ) {
      ctx.commit('SET_PROVISIONALSCHEME', [...payload.list])
      const {batch, enrollCategory, enrollMode, enrollStage, diplomaId, batchEx, academicYear, wenli} =
        ctx.state.batch
      if (!ctx.state.zybId) {
        saveDrafts({
          clientId: ctx.state.clientInfo.clientId,
          zybId: ctx.state.zybId || '0',
          draftsId: 0,
          enrollCategory,
          enrollMode,
          diplomaId,
          batch,
          batchEx,
          enrollStage,
          academic_year: academicYear,
          wenli,
          zyContent: ctx.getters.getProvisionalScheme,
        }).then(() => {
          // message.success('草稿自动已保存')
        })
      }
      // 只要不是点击排序触发的改变就清空排序规则，因为顺序就变了
      if (!payload.changeSortType) {
        ctx.commit('setZybSortType', 0)
      }
    },
    // 清空志愿表
    clearTemporaryZyScheme(ctx: any) {
      ctx.commit('setTemporaryZyScheme', [])
    },
    // 保存正式志愿表
    async saveZybScheme(ctx, payload: { callback: Function }) {
      const {batch, enrollCategory, enrollMode, enrollStage, diplomaId, batchEx} = ctx.state.batch
      const {zy_no, zy_seq, major_no} = ctx.state.zyb_conf
      const p = {
        clientId: ctx.state.clientInfo.clientId,
        zybId: ctx.state.zybId || '0',
        enrollCategory,
        enrollMode,
        diplomaId,
        batch,
        batchEx,
        enrollStage,
        title: ctx.state.zybName ? ctx.state.zybName.replace(/\s+/g, "") : "",
        description: '',
        zyNo: zy_no,
        zySeq: zy_seq,
        majorNo: major_no,
        zyContent: ctx.state.provisionalScheme,
        needSync: 0,
        needConfirm: 0,
      }
      if (p.zyContent && p.zyContent.length > 0) {
        for (let i = 0; i < p.zyContent.length; i++) {
          p.zyContent[i].snap = {
            admissionHeader: ctx.state.currentRecommendConf.admissionHeader,
            enrollLatestYear: ctx.state.currentRecommendConf.enrollLatestYear,
            batchName: ctx.state.batch.batchName,
            courseDesc: ctx.state.scoreDetail.course_desc,
            stuProvinceIdDesc: ctx.state.scoreDetail.stu_province_id_desc,
            user_diploma_score: ctx.state.scoreDetail.user_diploma_score,
          }
        }
      }
      const rsp = await saveZySchemeV2(p)
      if (payload.callback) {
        payload.callback(rsp)
      }
    },
  },
}
